export default "__VITE_ASSET__Ziw0DYy3__"